@let vm = wallet();
@let iconSize = this.iconSize()[size()];

<div
  class="wallet"
  [ngClass]="'wallet-' + size()"
  [class.justify-center]="size() === 'xxs'"
>
  @if (size() === "xxs") {
    <span class="currency d-flex align-center justify-center">
      <fu-icon
        [size]="iconSize"
        [iconName]="vm.currency?.symbol?.toLowerCase() ?? 'wallet'"
      ></fu-icon>
    </span>
  } @else {
    @if (size() !== "m") {
      <div class="wallet-header">
        <span class="wallet-currency d-flex align-center">
          <fu-icon
            [size]="iconSize"
            [iconName]="vm.currency?.symbol?.toLowerCase() ?? 'wallet'"
          ></fu-icon>
          {{ vm.currency?.name }}
        </span>
      </div>
    }
    <div class="wallet-description d-flex flex-col gap-1">
      <div
        class="wallet-balance crypto"
        [class.wallet-balance-m]="size() === 'm'"
      >
        <span class="currency">
          {{ vm?.currency?.symbol }}
          @if (showNetwork()) {
            <span>({{ vm?.currency?.network }})</span>
          }
        </span>
        <span [title]="vm?.balance">
          @let balance = vm?.balance | decimal: "1.2-8";
          {{ !useBalanceMask() ? balance : (balance | maskBalance) }}
        </span>
      </div>
      <div class="d-flex flex-col gap-1">
        @if (size() === "xl") {
          <div class="wallet-details d-flex align-center gap-4">
            <span class="wallet-name">
              {{ "cardView.cryptoWallet.label.id" | translate }}</span
            >
            <span class="wallet-address d-flex align-center">
              <span class="separation-dot"></span>
              <span class="wallet-id">{{ shortAddress(vm?.id) }}</span>
              <iw-button
                size="s"
                class="copy"
                uiType="custom"
                (click)="$event.stopPropagation(); copy(vm.id, 'clipboard.id')"
                ><fu-icon iconName="copy" size="16" />
              </iw-button>
            </span>
          </div>
        } @else {
          <div class="wallet-details d-flex align-center gap-4">
            <span class="wallet-address">{{
              "cardView.cryptoWallet.label.address" | translate
            }}</span>
            <span class="wallet-address d-flex align-center">
              <span class="separation-dot"></span>
              <span class="wallet-id">{{ shortAddress(vm?.address) }}</span>
              <iw-button
                size="s"
                class="copy"
                uiType="custom"
                (click)="
                  $event.stopPropagation();
                  copy(vm.address, 'clipboard.cryptoAddressCopied')
                "
                ><fu-icon iconName="copy" size="16" />
              </iw-button>
            </span>
          </div>
        }
      </div>
    </div>
  }
</div>
